// export type TAsyncTuple<ErrorType = unknown, DataType = unknown> =
//   | {
//       error: ErrorType;
//       data: null;
//     }
//   | { error: null; data: DataType };

// /**
//  * Gracefully handles a given Promise factory.
//  * @example
//  * const { error, data } = await handleAsync(() => asyncAction())
//  */
// export const handleAsync = async <ErrorType = unknown, DataType = unknown>(
//   promise: () => Promise<DataType>,
// ): Promise<TAsyncTuple<ErrorType, DataType>> => {
//   try {
//     const data = await promise().catch((error: ErrorType) => {
//       throw error instanceof Error ? error : new Error(String(error));
//     });
//     return { error: null, data };
//   } catch (error) {
//     console.error(error);
//     return { error: error as ErrorType, data: null };
//   }
// };
export type TAsyncTuple<ErrorType = unknown, DataType = unknown> =
  | {
      error: ErrorType;
      data: null;
      status?: number;
      message?: string | null;
    }
  | {
      error: null;
      data: DataType;
      status?: number;
      message?: string | null;
    };

export const handleAsync = async <ErrorType = unknown, DataType = unknown>(
  promise: () => Promise<any>,
): Promise<TAsyncTuple<ErrorType, DataType>> => {
  try {
    const response = (await promise()) as DataType;

    // Safely extract status and message if they exist on the response
    const status =
      typeof response === "object" && response !== null && "status" in response
        ? (response as { status?: number }).status
        : undefined;
    const message =
      typeof response === "object" &&
      response !== null &&
      "statusText" in response
        ? ((response as { statusText?: string }).statusText ?? null)
        : null;

    return {
      error: null,
      data: response,
      status,
      message,
    };
  } catch (err: unknown) {
    // Narrow the error type before accessing properties
    let status: number | undefined;
    let message: string | null = "Something went wrong";

    if (
      typeof err === "object" &&
      err !== null &&
      "response" in err &&
      typeof (err as { response?: unknown })?.response === "object"
    ) {
      const errorObj = err as {
        response?: { status?: number };
        message?: string;
      };

      status = errorObj.response?.status;
      message = errorObj.message ?? message;
    } else if (err instanceof Error) {
      message = err.message;
    }
    return {
      error: err as ErrorType,
      data: null,
      status,
      message,
    };
  }
};
